import angular from 'angular';

angular
    .module('lad-mock')

    .factory('LadMockService', [
        '$resource',
        '$http',
        'API_CONFIG',        
        function($resource, $http, API_CONFIG) {
            var LadMock = $resource(
                API_CONFIG.url + '/v1/lad-mock',
                {},
                {
                    // Recherche les noms de fichiers dans le répertoire 'out'
                    findFiles: {
                        method: 'GET',
                        isArray: false
                    },
                    generateIndexFile: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/lad-mock/generateIndexFile'
                    }        
                }                
            );

            LadMock.getPdfFileSize = function(pdfFilename) {
                return $http.get(API_CONFIG.url + '/v1/lad-mock/'+pdfFilename+'/pdf/size');
            }

            return LadMock;
        }
    ]);
